<div class="d-flex min-vh-100 content-color" [class.rtl]="rtl">
  <div
    class="overlay"
    *ngIf="isSidebarOpen"
    (click)="closeSidebar()"
    style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 1000; background: rgba(0,0,0,0.3);"
  ></div>

  <app-sidebar
    (sidebarClosed)="closeSidebar()"
    [isSidebarOpen]="isSidebarOpen"
  ></app-sidebar>

  <!-- Main Area -->
  <div
    class="flex-grow-1 d-flex flex-column "
[ngStyle]="{
  'margin-left': !isMobile && !rtl ? 'clamp(250px, 22vw, 345px)' : '0',
  'margin-right': !isMobile && rtl ? 'clamp(250px, 22vw, 345px)' : '0',
  'transition': 'margin 0.3s ease'
}"
    style="max-width: 100%;"
  >
    <div class="d-flex align-items-center border-bottom">
      <button
        class="burger-btn d-lg-none m-2"
        *ngIf="!isSidebarOpen || isBurgerAnimating"
        [class.open]="isBurgerAnimating"
        (click)="openSidebar()"
      >
        <span class="burger-line line1"></span>
        <span class="burger-line line2"></span>
        <span class="burger-line line3"></span>
      </button>

      <div class="flex-grow-1 py-3 px-2 px-lg-4">
        <!-- Topbar -->
        <ng-container *ngIf="topbarService.topbarComponent() as topbarCmp">
          <ng-container
            *ngComponentOutlet="topbarCmp; inputs: topbarService.topbarInputs()"
          ></ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Page content -->
    <main class="flex-grow-1 p-4" (click)="closeSidebar()">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<app-loading
  *ngIf="loading$ | async"
  [message]="'loadingMessage' | translate"
></app-loading>
